const Heading = {
  baseStyle: {
    fontWeight: "600"
  },
};

export default Heading;
